import { gameConfigurationStore } from '../gameModule/store/gameConfigurationStore';

// RU: клетка доски под указателем: колонка (барабан) и строка окна, вне доски — -1.
//     Указатель переводится в координаты самого контейнера барабанов (`element.toLocal`): в них
//     стоят и барабаны (`finalPositionX` — центр колонки), и клетки окна (`yInWin` — центр строки).
//     Граница колонок — середина промежутка между барабанами.
//     Прежде позиция бралась в координатах РОДИТЕЛЯ контейнера, и из неё вычиталось мировое
//     смещение контейнера (`tx`, только на вебе) с поправкой «+22». Под ядром 3.x контейнер
//     сдвинут внутри родителя, и формула промахивалась: на вебе колонка не находилась почти нигде
//     (свайп по барабанам был мёртв), на мобиле выходила соседней.
export function mousePositionToIconColumnRow(element, mouseEvent) {
  const local = element.toLocal(mouseEvent.data.global);
  const { reelsParams } = gameConfigurationStore;
  const {
    visibleRows,
    iconsFinalPositions: { inWinContainer },
    iconsHeight,
    iconsWidth,
  } = reelsParams[0];

  const column = reelsParams.findIndex(({ finalPositionX, spacing }) => {
    const halfSpan = (iconsWidth + spacing) / 2;
    return local.x >= finalPositionX - halfSpan && local.x < finalPositionX + halfSpan;
  });

  const row = inWinContainer
    .slice(visibleRows, visibleRows * 2)
    .findIndex(
      ({ yInWin }) => local.y >= yInWin - iconsHeight / 2 && local.y < yInWin + iconsHeight / 2
    );

  return { column, row };
}
